<template>
    <svg
        enable-background="new 0 0 32 32"
        height="512"
        viewBox="0 0 32 32"
        width="512"
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
    >
        <path d="m27.943 4.044c-4.032-4.032-12.213-1.94-19.025 4.872s-8.907 14.992-4.872 19.028c1.188 1.187 2.734 1.853 4.515 2.014-5.51-3.343-.398-12.555 4.228-17.171 4.631-4.622 13.835-9.734 17.169-4.217-.161-1.785-.825-3.336-2.015-4.526zm-19.743 12.156h-2v-2h2zm3.8-4.2h-2v-2h2zm4.2-3.8h-2v-2h2z" />
        <path d="m19.211 23.139c.809 1.247.455 2.913-.79 3.724-5.638 3.663-11.247 3.423-10.61-2.332 1.859.169 5.035-.463 7.677-2.182 1.245-.807 2.911-.456 3.723.79z" />
        <path d="m22.349 15.488c1.719-2.642 2.351-5.818 2.182-7.677 5.755-.637 5.995 4.971 2.332 10.61-.81 1.246-2.477 1.6-3.724.79-1.246-.812-1.597-2.478-.79-3.723z" />
    </svg>
</template>
